// extracted by mini-css-extract-plugin
export default {"modal":"VideoModal_modal__OCY4V","content":"VideoModal_content__P8ffX","video":"VideoModal_video__tl8jg","ov":"VideoModal_ov__iWPd+"};